import { Button, Stack } from '@mui/material'
import { EquipmentPlannedDto, StoppageResponseDto } from '@operations/app/api'
import { useOperationsStore } from '@operations/AppProvider'
import { StoppageForm } from '@operations/features/stoppage/components/molecules/StoppageForm'
import { useStoppageMessageHandler } from '@operations/features/stoppage/hooks/useStoppageMessageHandler'
import { StoppageFormData } from '@operations/stores/StoppageStore'

import { useTranslate } from '@tolgee/react'
import { CloseButton, ContainerMobile, Header, useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'

interface IProps {
  vesselVisitId: number
  visitName?: string
  selectedCrane: EquipmentPlannedDto
  stoppage?: StoppageResponseDto
  onClose: () => void
  onRecordStoppage: () => void
}

export const Stoppage = observer(
  ({ vesselVisitId, selectedCrane, stoppage, visitName, onClose, onRecordStoppage }: IProps) => {
    const { t } = useTranslate()
    const theme = useMinimalsTheme()
    const { stoppageStore, stoppageReasonStore, appStore } = useOperationsStore()

    const { getExceptionMessage, getSuccessMessage } = useStoppageMessageHandler()

    const formId = 'stoppageForm'

    const handleSubmit = async (formData: StoppageFormData) => {
      try {
        await stoppageStore.onSubmit(formData)
        appStore.setShowAlert('success', getSuccessMessage(!!formData.id))
        onRecordStoppage()
      } catch (error) {
        appStore.setShowAlert('error', getExceptionMessage(error))
      }
    }

    return (
      <>
        <Header
          title={
            stoppage ? t('editStoppage', 'Edit stoppage') : t('recordStoppage', 'Record stoppage')
          }
          subTitle={`${visitName ?? t('selectedCrane', 'Selected crane')} - ${selectedCrane.name}`}
          leftRenderOption={<CloseButton onClose={onClose} />}
          rightRenderOption={
            <Button variant='contained' type='submit' form={formId} data-cy='stoppage-save-btn'>
              {t('save', 'Save')}
            </Button>
          }
        />
        <ContainerMobile sx={{ pt: theme.customSpacing.l }}>
          <Stack gap={theme.customSpacing.m}>
            <StoppageForm
              formId={formId}
              vesselVisitId={vesselVisitId}
              stoppage={stoppage}
              stoppageReasons={stoppageReasonStore.items}
              equipments={stoppageStore.cranes}
              defaultEquipmentId={selectedCrane.id}
              onSubmit={handleSubmit}
              setDateAutomatically={true}
            />
          </Stack>
        </ContainerMobile>
      </>
    )
  },
)
